export const actions = {
  async nuxtServerInit({ dispatch }) {
    await Promise.all([dispatch('global/loadNavigations')])
  },
}
